import React from "react";
import "./FilterDates.scss";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";
import moment from "moment";

const FilterDates = ({ formik, lable }: { formik: any; lable?: string }) => {
  const onChangeStartDate = (e: any) => {
    formik.setFieldValue(
      "startDate",
      moment(new Date(e))?.format("YYYY-MM-DD")
    );
  };

  const onChangeEndDate = (e: any) => {
    formik.setFieldValue("endDate", moment(new Date(e))?.format("YYYY-MM-DD"));
  };

  return (
    <div className="filter-new-date-contain">
      <p className="date-head">{lable ? lable : "Date Created"} </p>
      <div className="start-date filter-date-input-contain">
        <p className="date-lable">Start Date</p>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            className={`filter-date-input`}
            value={dayjs(new Date(formik?.values?.startDate))}
            format="DD/MM/YYYY"
            onChange={onChangeStartDate}
          />
        </LocalizationProvider>
      </div>

      <div className="start-date filter-date-input-contain">
        <p className="date-lable">End Date</p>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            className={`filter-date-input`}
            value={dayjs(new Date(formik?.values?.endDate))}
            format="DD/MM/YYYY"
            onChange={onChangeEndDate}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default FilterDates;
